import { useIntl } from 'react-intl';

import { IBudgetVersionService } from "../../../../../models/budgetV2";
import { BudgetPercentageInput } from "../../budgetInputs/BudgetPercentageInput";

interface IBudgetServicePercentagesProps {
    service: IBudgetVersionService;
    calculatedSubtotal: number;
    calculatedTruckerPayPlanSubtotal: number;

    setService: (service: IBudgetVersionService) => void;
}

export const BudgetServicePercentages = (props: IBudgetServicePercentagesProps) => {
    const intl = useIntl();

    const { service, calculatedSubtotal, calculatedTruckerPayPlanSubtotal, setService } = props;

    return (
        <div className={`flex flex-row gap-10 flex-wrap items-start flex-shrink-0`}>
            <div className={`flex w-full md:w-[160px] flex-col flex-shrink-0 mb-4`}>
                <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">{intl.formatMessage({ id: 'intl-msg:budgets.clientPercentage' })}</div>
                <BudgetPercentageInput
                    value={((calculatedSubtotal ?? 0) - (calculatedTruckerPayPlanSubtotal ?? 0)) / (calculatedSubtotal ?? 0) * 100}
                    onChange={() => { }}
                    placeholder="00%"
                    disabled={true}
                />
            </div>
            <div className={`flex w-full md:w-[160px] flex-col flex-shrink-0 mb-4`}>
                <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">{intl.formatMessage({ id: 'intl-msg:budgets.maintenancePlanPercentage' })}</div>
                <BudgetPercentageInput
                    value={calculatedTruckerPayPlanSubtotal / (calculatedSubtotal ?? 0) * 100}
                    onChange={() => { }}
                    placeholder="00%"
                    disabled={true}
                />
            </div>
            <div className={`flex w-full md:w-[160px] flex-col flex-shrink-0 mb-4`}>
                <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">{intl.formatMessage({ id: 'intl-msg:budgets.dealershipPercentage' })}</div>
                <BudgetPercentageInput
                    value={service.percentages?.dealership ?? 0}
                    onChange={(value) => {
                        setService({
                            ...service,
                            percentages: {
                                ...service.percentages,
                                dealership: value
                            }
                        });
                    }}
                    placeholder="00%"
                    max={Math.max(0, 100 - (calculatedTruckerPayPlanSubtotal + (service.percentages?.warranty || 0)))}
                    disabled={!service.isExternalService}
                />
            </div>
            <div className={`flex w-full md:w-[160px] flex-col flex-shrink-0 mb-4`}>
                <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">{intl.formatMessage({ id: 'intl-msg:budgets.warrantyPercentage' })}</div>
                <BudgetPercentageInput
                    value={service.percentages?.warranty ?? 0}
                    onChange={(value) => {
                        setService({
                            ...service,
                            percentages: {
                                ...service.percentages,
                                warranty: value
                            }
                        });
                    }}
                    placeholder="00%"
                    max={Math.max(0, 100 - (calculatedTruckerPayPlanSubtotal + (service.percentages?.dealership || 0)))}
                    disabled={!service.isExternalService}
                />
            </div>
        </div>
    )
}